import { StyleSheet } from "@react-pdf/renderer";

export const colors = {
  azul: "#2f7bbf",
  negro: "#000",
  grisClaro: "#e6e6e6",
};

export const pdfStyles = StyleSheet.create({

  // ======== PÁGINA GENERAL ========
  page: {
    paddingTop: 110,
    paddingBottom: 95,
    paddingHorizontal: 45,
    fontSize: 8,
    fontFamily: "Helvetica",
    lineHeight: 1.45,
    color: colors.negro,
  },

  headerImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 100,
  },

  footerImage: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: 85,
  },

  // ===== TITULOS =====
  mainTitle: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
    marginTop: 5,
    color: colors.azul,
  },

  sectionTitle: {
    backgroundColor: colors.azul,
    color: "#fff",
    paddingVertical: 6,
    paddingLeft: 10,
    fontSize: 8,
    fontWeight: "bold",
    marginTop: 8,
    marginBottom: 8,
  },

  // ===== BULLETS =====
  bulletRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 6,
    paddingLeft: 6,
  },

  bulletPoint: {
    fontSize: 8,
    marginRight: 6,
    lineHeight: 1.25,
  },

  bulletText: {
    fontSize: 8,
    lineHeight: 1.35,
  },

  // ===== TEXTOS =====
  paragraph: {
    fontSize: 8,
    lineHeight: 1.40,
    marginBottom: 12,
    paddingLeft: 6,
    paddingRight: 6,
    textAlign: "justify",
  },

  italicParagraph: {
    fontSize: 8,
    fontStyle: "italic",
    lineHeight: 1.35,
    paddingLeft: 6,
    paddingRight: 6,
    textAlign: "justify",
    marginBottom: 10,
  },

  // ===== SECCIÓN INFO (CLIENTE - COTIZACIÓN) =====
  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
  },

  infoBox: {
    width: "48%",
  },

  infoText: {
    marginBottom: 3,
    fontSize: 8,
  },

  // ===== TABLA =====
  table: {
    width: "100%",
    marginTop: 8,
    borderWidth: 1,
    borderColor: colors.azul,
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: colors.azul,
    color: "#fff",
  },

  th: {
    padding: 5,
    fontSize: 8,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#fff",
    fontWeight: "bold",
  },

  td: {
    padding: 4,
    fontSize: 8,
    textAlign: "center",
  },

  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: colors.grisClaro,
  },

  // ===== TOTALES =====
  totalsBox: {
    marginTop: 8,
    alignSelf: "flex-end",
    width: 180,
    fontSize: 10,
  },

  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
    fontSize: 10,
  },

  totalHighlight: {
    backgroundColor: "yellow",
    padding: 4,
    fontWeight: "bold",
  },

  // ===== CONDICIONES DE COTIZACIÓN =====
  condicionesList: {
    marginTop: 2,
  },

  condicionRow: {
    flexDirection: "row",
    marginBottom: 2,
  },

  miniBullet: {
    width: 6,
    height: 6,
    backgroundColor: colors.azul,
    borderRadius: 3,
    marginRight: 5,
    marginTop: 1,
  },

  firmaText: {
  position: "absolute",
  bottom: 120,   // Ajustá este valor según la altura real de tu footer.jpeg
  left: 45,
  width: "70%",
  fontSize: 8,
},

  // MENSAJE FINAL
  finalMessage: {
    marginTop: 20,
    textAlign: "center",
    fontSize: 8,
  },
});
